<script lang="ts">
  export let text = "";
  export let marginTop = "34px";
  export let marginBottom = "34px";
  export let separatorColor = "var(--crayola)";
  export let color = "var(--crayola)";
  export let backgroundColor = "var(--chinese-black)";

</script>

<div class="separator" style="margin-top: {marginTop}; margin-bottom: {marginBottom}; background-color: {separatorColor}">
  <span class="text" style="color: {color}; background-color: {backgroundColor}">{text}</span>
</div>

<style>
  .separator {
    position: relative;
    height: 1px;
  }


  .text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 0 12px;
    height: fit-content;
    text-transform: uppercase;
  }
</style>
